import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetAlgoAccess } from '../../pages/Admin/algoDeviceSupport';
import {
  clearSupportedTenantSession,
  readSupportedTenantSession,
  subscribeSupportedTenantSession,
  supportBannerLabel,
} from '../../pages/Admin/supportedTenantsSession';

export default function SupportContextBanner() {
  const navigate = useNavigate();
  const [session, setSession] = useState(() => readSupportedTenantSession());

  useEffect(() => subscribeSupportedTenantSession(() => {
    setSession(readSupportedTenantSession());
  }), []);

  if (!session?.tenantId) return null;

  const leave = (path) => {
    clearSupportedTenantSession();
    resetAlgoAccess();
    navigate(path);
  };

  return (
    <div
      data-testid="support-banner"
      className="flex flex-wrap items-center gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-950"
    >
      <span className="font-medium">
        {`Supporting ${session.name || session.tenantId} — ${supportBannerLabel(session.accessLevel)}`}
      </span>
      <button type="button" data-support-allow="true" className="rounded border border-amber-400 bg-white px-2 py-1" onClick={() => leave('/support/tenants')}>
        Switch tenant
      </button>
      <button type="button" data-support-allow="true" className="rounded border border-amber-400 bg-white px-2 py-1" onClick={() => leave('/home')}>
        Exit support
      </button>
    </div>
  );
}
